import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { TabsWrapper, TabButton } from './styles/ContactTabsStyles';

const TABS = [
  { id: 'operators', message: 'operator.dashboard.tab.operators' },
  { id: 'favorites', message: 'operator.dashboard.tab.favorites' },
  { id: 'callHistory', message: 'operator.dashboard.tab.callHistory' },
];

/**
 * 連絡先のタブコンポーネント。
 * 作業者一覧とお気に入り一覧、通話履歴のタブを表示する。
 *
 * @param {Object} props
 * @param {string} props.currentTab - 現在選択中のタブ
 * @param {function} props.setCurrentTab - 現在のタブを設定する関数
 */
const ContactTabs = ({ currentTab, setCurrentTab }) => (
  <TabsWrapper>
    {TABS.map(({ id, message }) => {
      const isActive = currentTab === id;
      return (
        <TabButton
          key={id}
          className={!isActive && 'button'}
          large
          active={isActive}
          onClick={() => !isActive && setCurrentTab(id)}
        >
          <FormattedMessage id={message} />
        </TabButton>
      );
    })}
  </TabsWrapper>
);

ContactTabs.propTypes = {
  currentTab: PropTypes.object.isRequired,
  setCurrentTab: PropTypes.func.isRequired,
};
export default ContactTabs;
